import React from 'react';
import { GATOR_BACKUP_PLANS, HIGHLIGHT_ID, PLAN_CYCLE_TYPES } from '@/pages/GatorBackup/GatorBackupHandler/GatorBackup.enum';

export default {
  title: (
    <>
      Sem Backup, um erro pode apagar
      {' '}
      <span>seu site!</span>
    </>
  ),
  description: 'Proteja seu negócio contra falhas, ataques e erros humanos. Ative o backup automático e nunca mais pare de vender. Seu site sempre online.',
  highlights: [
    {
      id: HIGHLIGHT_ID.BACKUP_AUTO,
      title: 'Backup automático',
      description: 'Seu site é salvo sozinho. Se algo der errado, não perca nada!',
    },
    {
      id: HIGHLIGHT_ID.BACKUP_CLOUD,
      title: 'Backup na nuvem em 1 clique',
      description: 'Você recupera o site inteiro ou só um arquivo com um clique.',
    },
    {
      id: HIGHLIGHT_ID.BACKUP_ALERT,
      title: 'Avisos de alterações e ameaças',
      description: 'Receba alertas e acompanhe alterações antes que virem problema.',
    },
  ],
  domain: {
    label: 'Selecione ou digite seu domínio',
    toggleLabel: 'Digitar outro domínio',
    placeholder: 'Domínio',
    textFieldPlaceholder: 'Digite seu domínio ex: ”meudominio.com.br”',
    errorMessage: 'Formato inválido. Digite apenas o nome do domínio (ex: seudominio.com.br)',
  },
  plan: {
    label: 'Escolha o plano de Backup do seu site',
    options: {
      [PLAN_CYCLE_TYPES.ANNUALLY]: '1 ano',
      [PLAN_CYCLE_TYPES.SEMIANNUALLY]: '6 meses',
      [PLAN_CYCLE_TYPES.QUARTERLY]: '3 meses',
      [PLAN_CYCLE_TYPES.MONTHLY]: '1 mês',
    },
  },
  tablePlans: {
    badge: 'Recomendado',
    advantages: 'Vantagens:',
    priceSymbol: 'R$',
    priceSuffix: '/mês*',
    pricePerCycle: {
      [PLAN_CYCLE_TYPES.ANNUALLY]: price => `${price} por 1 ano`,
      [PLAN_CYCLE_TYPES.SEMIANNUALLY]: price => `${price} por 6 meses`,
      [PLAN_CYCLE_TYPES.QUARTERLY]: price => `${price} por 3 meses`,
    },
    ctaTitleValidation: 'Selecione seu domínio antes de escolher o plano de backup.',
    options: {
      [GATOR_BACKUP_PLANS.CORE]: {
        name: 'Plano Core',
        cta: 'Quero o Core',
        highlights: [
          (
            <React.Fragment key="1">
              <b>1 GB</b>
              {' '}
              de armazenamento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>5 sites</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup todo dia',
          'Retenção de backup ilimitado',
          'Cópias de segurança incrementais',
          'Restaurar o site inteiro com um clique',
          'Backup do banco de dados',
          'Notificações de alterações (Exibe histórico de alterações e envia e-mail quando o site é modificado)',
          'Restauração seletiva (restauração em nível de arquivo)',
          'Baixar Backup',
        ],
      },
      [GATOR_BACKUP_PLANS.PLUS]: {
        name: 'Plano Plus',
        cta: 'Quero o Plus',
        highlights: [
          (
            <React.Fragment key="1">
              <b>5 GB</b>
              {' '}
              de armazenamento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>10 sites</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup todo dia',
          'Retenção de backup ilimitado',
          'Cópias de segurança incrementais',
          'Restaurar o site inteiro com um clique',
          'Backup do banco de dados',
          'Notificações de alterações (Exibe histórico de alterações e envia e-mail quando o site é modificado)',
          'Restauração seletiva (restauração em nível de arquivo)',
          'Baixar Backup',
          'Cópias de segurança manuais quanto quiser',
          'Filas prioritárias',
        ],
      },
      [GATOR_BACKUP_PLANS.ADVANCED]: {
        name: 'Plano Advanced',
        cta: 'Quero o Advanced',
        highlights: [
          (
            <React.Fragment key="1">
              <b>10 GB</b>
              {' '}
              de armazenamento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>25 sites</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup todo dia',
          'Retenção de backup ilimitado',
          'Cópias de segurança incrementais',
          'Restaurar o site inteiro com um clique',
          'Backup do banco de dados',
          'Notificações de alterações (Exibe histórico de alterações e envia e-mail quando o site é modificado)',
          'Restauração seletiva (restauração em nível de arquivo)',
          'Baixar Backup',
          'Cópias de segurança manuais quanto quiser',
          'Filas prioritárias',
        ],
      },
      [GATOR_BACKUP_PLANS.MAX]: {
        name: 'Plano Max',
        cta: 'Quero o Max',
        highlights: [
          (
            <React.Fragment key="1">
              <b>25 GB</b>
              {' '}
              de armazenamento
            </React.Fragment>
          ),
          (
            <React.Fragment key="2">
              <b>100 sites</b>
              {' '}
              para backups
            </React.Fragment>
          ),
          'Backup todo dia',
          'Retenção de backup ilimitado',
          'Cópias de segurança incrementais',
          'Restaurar o site inteiro com um clique',
          'Backup do banco de dados',
          'Notificações de alterações (Exibe histórico de alterações e envia e-mail quando o site é modificado)',
          'Restauração seletiva (restauração em nível de arquivo)',
          'Baixar Backup',
          'Cópias de segurança manuais quanto quiser',
          'Filas prioritárias',
        ],
      },
    },
  },
};
